<template>
  <div>
    <div class="mx-auto max-w-480 company-search hidden lg:block md:block">
      <AutoComplete
        page="company"
        :param-prop="params"
        v-if="currentBreakpoint === breakpointRefSize"
      />
    </div>
    <div class="mx-auto company-search md:hidden">
      <AutoComplete
        page="company"
        :param-prop="params"
        v-if="currentBreakpoint === breakpointSmallerSize"
      />
    </div>

    <div class="page-content">
      <div class="mt-10 mb-2 md:mt-12 md:mb-116px xl:mt-16 p-s md:pb-0 xl:p-0">
        <h2 class="font-bold c-popular leading-12 mb-8px">
          {{ popularCompaniesHeading }}
        </h2>
        <company-hits :jobs-count="jobsCount" :param-prop="params" />
        <div class="hidden"><ais-refinement-list attribute="id" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import BreakpointMixin from '../mixins/BreakpointMixin';
import { mediaQuerySizes } from '../utils';

import AutoComplete from './AutoComplete.vue';
import CompanyHits from './CompanyHits.vue';

export default {
  name: 'CompanyWrapper',
  components: {
    AutoComplete,
    CompanyHits,
  },
  data() {
    const breakpointRefSize = 'md';

    return {
      params: this.paramProp,
      breakpointRefSize: breakpointRefSize,
      breakpointSmallerSize:
        mediaQuerySizes[mediaQuerySizes.indexOf(breakpointRefSize) - 1],
    };
  },
  mixins: [BreakpointMixin],
  props: {
    jobsCount: {
      type: Object,
      required: true,
    },
    popularCompaniesHeading: {
      type: String,
      required: true,
    },
    paramProp: {
      default: undefined,
    },
  },
};
</script>
